import Hero from "@/components/sections/Hero";
import Casa3DShowcase from "@/components/sections/Casa3DShowcase";
import BuyerDemo from "@/components/sections/BuyerDemo";
import CasamoreScore from "@/components/sections/CasamoreScore";
import AffittoBreveOwner from "@/components/sections/AffittoBreveOwner";
import { Marquee } from "@/components/Footer";
import useSEO from "@/hooks/useSEO";

export default function Home({ onValuation }) {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  useSEO({ title: "Casamore Group — Agenzia Immobiliare a Corato | Vendita, Affitto e Affitti Brevi", description: "Casamore Group, agenzia immobiliare a Corato: vendita e affitto di case e immobili, affitti brevi in Puglia, valutazioni gratuite, simulatore mutuo e consulenza dedicata.", canonical: window.location.origin + "/" });

  return (
    <>
      <Hero onValuation={onValuation} onScrollBuyers={() => scrollTo("acquirenti")} />
      <Casa3DShowcase />
      <BuyerDemo onVerify={onValuation} />
      <Marquee />
      <CasamoreScore onCalculate={onValuation} />
      <AffittoBreveOwner />
    </>
  );
}
